import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ProductosService } from 'src/app/services/productos.service';

@Component({
  selector: 'app-pedidos',
  templateUrl: './pedidos.component.html',
  styleUrls: ['./pedidos.component.scss']
})
export class PedidosComponent implements OnInit {

  public user = this.authSvc.afAuth.user;
  usuario: any;
  pedidos: any;
  carrito: any;
  subtotal: number;
  descuento: number;
  total: number;
  fecha: number;
  comprador: string;
  email: string;
  telefono: string;
  constructor(private productosSvc: ProductosService,
              private authSvc: AuthService) { }

  ngOnInit(): void {
    this.user.subscribe(usr => {
      this.usuario = usr;
      const idUser = this.usuario.uid;
      this.productosSvc.cargarPedidosPorUsuario(idUser)
                       .subscribe(res => {
                          this.pedidos = res;
                       });
    });
  }

  detalle(lista: any){
    this.carrito = lista.carrito;
    this.subtotal = lista.subtotal;
    this.descuento = lista.descuento;
    this.total = lista.total;
    this.fecha = lista.fecha;
    this.comprador = lista.nombre;
    this.email = lista.email;
    this.telefono = lista.telefono;
  }

}
